import React from "react";
import { motion } from "framer-motion";

// Scroll-reveal wrapper using framer-motion. Reliable across re-renders
// (e.g. language toggle) and RTL. Animates once when scrolled into view.
export const Reveal = ({ children, delay = 0, className = "", ...rest }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15, margin: "0px 0px -60px 0px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: delay / 1000 }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};
